import React, { useState } from "react";
import GoogleRegister from "./socialOauth/google/googleRegister";

const SocialSignup = () => {

  const [authError, setAuthError] = useState(false);
  const [authErrorMsg, setAuthErrorMsg] = useState("");

  return (
    <>
      <div className="text-center social-auth-container">
        <GoogleRegister setAuthError={setAuthError} setAuthErrorMsg={setAuthErrorMsg} />
        {authError &&
          <div className={'alert alert-danger mt-3'}>{authErrorMsg}</div>
        }
      </div>
    </>
  );
};

export default SocialSignup;
